module.exports = __webpack_public_path__ + "img/t4-11.f6b01c1b.svg";